<template>
	<div style="overflow-x: hidden;background-color: #F8FAFF;overflow-y: hidden;">
		<navbar></navbar>
		<div id="box">
			<div style="width: 100%;">
				<center>
					<h1 style="font-size: 1.75rem;">{{$t('block.title')}}</h1>
				</center>
			</div>
			<el-divider></el-divider>
			<div style="vertical-align: middle;line-height: 2.5rem;">
				<h1 style="float: left;">{{$t('block.selectcoin')}}</h1>
				<el-select v-model="value" @change="showtable(value)" >
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<el-table :data="tempblockData" border style="width: 100% ;margin: auto;margin-top: 1.25rem;"
				v-loading="loading">
				<el-table-column prop="id" :label="$t('block.table_id')" width="50"><template
						slot-scope="scope">{{scope.$index+1}}</template> </el-table-column>
				<el-table-column :resizable="false" prop="ts" :label="$t('block.table_ts')"> </el-table-column>
				<el-table-column :resizable="false" prop="effort" :label="$t('block.table_effort')"> </el-table-column>
				<el-table-column :resizable="false" prop="rawaward" :label="$t('block.table_rawaward')"> </el-table-column>
				<el-table-column :resizable="false" prop="payment" :label="$t('block.table_payment')">
					<template slot-scope="scope">
						<div v-if="isDone(scope.row.stat)">
							<!-- {{scope.row.payment}} -->
							<el-tooltip class="item" effect="dark" :content="appendPayment(scope.row.payment)"
								placement="bottom-end">
								<span>{{scope.row.stat}}</span>
							</el-tooltip>
						</div>

						<span v-else>
							{{scope.row.payment}}
						</span>
					</template>
				</el-table-column>
				<el-table-column :resizable="false" prop="height" :label="$t('block.table_blockheight')"> </el-table-column>
				<el-table-column :resizable="false" prop="hash" label="Tx Hash">
					<template slot-scope="scope">
						<el-link type="primary" :underline="false" target="_balck" :href="scope.row.url">
							{{ scope.row.hash}}
						</el-link>
					</template>
				</el-table-column>
			</el-table>
			<div class="paginationClass" style="width:100%;">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[5, 10, 20, 40]" :page-size="pagesize"
					layout="total, sizes, prev, pager, next, jumper" :total="total1">
				</el-pagination>
			</div>
		</div>
		<footerbar></footerbar>
	</div>
</template>

<script>
	import navbar from '../../toolbar/navbar.vue'
	import axios from "axios";
	import {
		formatDate
	} from '../../utils/dataUtil.js'
	import footerbar from '../../toolbar/footer.vue'
	export default {
		components: {
			navbar,
			axios,
			footerbar
		},
		data() {
			return {
				port: '',
				currentPage: 1, //初始页
				pagesize: 10, //    每页的数据
				userList: [],
				option: [],
				netheight: 0,
				pagenum: 0,
				value: '',
				COINS: {},
				blockConfig: {},
				blockData: [],
				tempblockData: [],
				statsConfig: {},
				total1: 0,
				url: '',
				loading: false,
				tableData: []
			}
		},
		created() {
			this.value = '18081'
			this.statsConfig = {
				method: 'get',
				url: 'https://api.c3pool.org/pool/stats',
				headers: {}
			};
			this.blockConfig = {
				method: 'get',
				url: 'https://api.c3pool.org/pool/coin_altblocks/8545?page=0&limit=15',
				headers: {}
			};
			this.options = [{
				value: '18081',
				label: 'XMR'
			}, {
				value: '18181',
				label: 'XMC'
			}, {
				value: '19734',
				label: 'SUMO'
			}, {
				value: '12211',
				label: 'RYO'
			}, {
				value: '18981',
				label: 'GRFT'
			}, {
				value: '38081',
				label: 'MSR'
			}, {
				value: '48782',
				label: 'LTHN'
			}, {
				value: '34568',
				label: 'WOW'
			}, {
				value: '19281',
				label: 'XMV'
			}, {
				value: '9231',
				label: 'XEQ'
			}, {
				value: '19950',
				label: 'XWP'
			}, {
				value: '8766',
				label: 'RVN'
			}, {
				value: '8545',
				label: 'ETH'
			}, {
				value: '11181',
				label: 'AEON'
			}, {
				value: '17750',
				label: 'XHV'
			}, {
				value: '20206',
				label: 'DERO'
			}, {
				value: '25182',
				label: 'TUBE'
			}, {
				value: '11812',
				label: 'XLA'
			}, {
				value: '33124',
				label: 'XTNC'
			}, {
				value: '11898',
				label: 'TRTL'
			}, {
				value: '13007',
				label: 'IRD'
			}, {
				value: '19994',
				label: 'ARQ'
			}, {
				value: '16000',
				label: 'CCX'
			}, {
				value: '9053',
				label: 'ERG'
			}];
			this.COINS = {
				18081: {
					name: "XMR",
					divisor: 1000000000000,
					url: "https://xmrchain.net",
					time: 120,
				},
				18181: {
					name: "XMC",
					divisor: 1000000000000,
					url: "http://explorer.monero-classic.org",
					time: 120,
				},
				19734: {
					name: "SUMO",
					divisor: 1000000000,
					url: "https://explorer.sumokoin.com",
					time: 240,
				},
				12211: {
					name: "RYO",
					divisor: 1000000000,
					url: "https://explorer.ryo-currency.com",
					time: 240,
				},
				18981: {
					name: "GRFT",
					divisor: 10000000000,
					url: "https://blockexplorer.graft.network",
					time: 120,
				},
				38081: {
					name: "MSR",
					divisor: 1000000000000,
					url: "https://explorer.getmasari.org",
					time: 60,
				},
				48782: {
					name: "LTHN",
					divisor: 100000000,
					url: "https://lethean.io/explorer",
					time: 120,
				},
				34568: {
					name: "WOW",
					divisor: 100000000000,
					url: "http://explore.wownero.com",
					time: 300,
				},
				19281: {
					name: "XMV",
					divisor: 100000000000,
					url: "https://explorer.monerov.online",
					time: 60,
					unit: "G",
					factor: 16,
				},
				9231: {
					name: "XEQ",
					divisor: 10000,
					url: "https://explorer.equilibria.network",
					time: 120,
				},
				19950: {
					name: "XWP",
					divisor: 1000000000000,
					url: "https://explorer.xwp.one",
					time: 15,
					unit: "G",
					factor: 32,
				},
				8766: {
					name: "RVN",
					divisor: 100000000,
					url: "https://ravencoin.network",
					time: 60,
					unit: "H",
					factor: 0xFFFFFFFFFFFFFFFF / 0xFF000000,
				},
				8545: {
					name: "ETH",
					divisor: 1000000000000000000,
					url: "https://etherscan.io/",
					time: 13,
					unit: "H",
					factor: 1,
				},
				11181: {
					name: "AEON",
					divisor: 1000000000000,
					url: "https://aeonblockexplorer.com",
					time: 240,
				},
				17750: {
					name: "XHV",
					divisor: 1000000000000,
					url: "https://explorer.havenprotocol.org",
					time: 120,
				},
				20206: {
					name: "DERO",
					divisor: 1000000000000,
					url: "https://explorer.dero.io",
					time: 27,
				},
				25182: {
					name: "TUBE",
					divisor: 1000000000,
					url: "https://explorer.bittube.cash",
					time: 15,
					unit: "G",
					factor: 40,
				},
				11812: {
					name: "XLA",
					divisor: 100,
					url: "https://explorer.scalaproject.io",
					time: 120,
				},
				33124: {
					name: "XTNC",
					divisor: 1000000000,
					url: "https://explorer.xtendcash.com",
					time: 120,
					unit: "G",
					factor: 32,
				},
				11898: {
					name: "TRTL",
					divisor: 100,
					url: "https://explorer.turtlecoin.lol",
					time: 30,
				},
				13007: {
					name: "IRD",
					divisor: 100000000,
					url: "https://explorer.ird.cash",
					time: 175,
				},
				19994: {
					name: "ARQ",
					divisor: 1000000000,
					url: "https://explorer.arqma.com",
					time: 120,
				},
				16000: {
					name: "CCX",
					divisor: 1000000,
					url: "https://explorer.conceal.network",
					time: 120,
				},
				9053: {
					name: "ERG",
					divisor: 1000000000,
					url: "https://explorer.ergoplatform.com/en",
					time: 120,
					unit: "H",
					factor: 1,
				}
			}
		},
		async mounted() {
			let that = this
			that.loading = true
			this.blockConfig = {
				method: 'get',
				url: 'https://api.c3pool.org/pool/blocks?page=0&limit=10',
				headers: {}
			};

			await axios(this.statsConfig)
				.then(function(response) {
					// console.log(response.data.pool_statistics.altBlocksFound['18181'])
					if (that.value === '18081') {
						that.total1 = response.data.pool_statistics.totalBlocksFound
					} else {
						that.total1 = response.data.pool_statistics.altBlocksFound[that.value]
					}

					// response.data.pool_statistics.altBlocksFound['18081']
				})
				.catch(function(error) {
					console.log(error);
				});
			let tmp = that.getNetHeight()
			await axios(this.$data.blockConfig)
				.then(function(response) {

					for (var item in response.data) {
						var pay = response.data[item].value

						if (response.data[item].valid === true) {

							if (response.data[item].unlocked === false) { //调试用 生产环境改为false
							// console.log("that.netheight:"+that.netheight)
								var b = 30 - (that.netheight - response.data[item].height)
								if (b > 0) {
									pay = ((b * 120) / 60) + that.$t('block.mins');
								} else if (b > -10) {
									pay =that.$t('block.soon');
								} else {
									pay =that.$t('block.delay');
								}

								// pay=that.getblockaward(18081, pay)// 
							} else {
								pay = that.getblockaward(18081, pay)
							}
						} else {
							pay = that.$t('block.nullify')
						}
						var temp = {
							"id": item,
							"ts": that.dateformat(response.data[item].ts /
								1000), //formatDate(response.data[item].ts),
							"effort": ((response.data[item].shares * 100 / response.data[item].diff).toFixed(
								0)) + '%',
							"rawaward": pay, //that.getblockaward(18081, response.data[item].value),
							"payment": pay, //that.getblockaward(18081, response.data[item].value),
							"height": response.data[item].height,
							"url": that.getblockurl(18081, response.data[item].hash),
							"hash": response.data[item].hash.slice(0, 5) + "******" + response.data[item].hash
								.slice(response.data[item].hash.length - 5, response.data[item].hash.length)
						}
						that.$data.tempblockData.push(temp)
					}
					that.loading = false
					// that.$data.tempblockData = response.data
					// // that.handleCurrentChange(1)
					// console.log(JSON.stringify(that.blockData));
				})
				.catch(function(error) {
					console.log(error);
				});

		},
		methods: {
			getNetHeight() {
				let that = this
				var tmpheight = 0
				var config = {
					method: 'get',
					url: 'https://api.c3pool.org/network/stats',
					headers: {}
				};

				axios(config)
					.then(function(response) {
						that.netheight = response.data.height
						tmpheight = response.data.height
						// console.log("response.data.height"+)
					})
					.catch(function(error) {
						console.log(error);
					});
				return tmpheight
			},
			dateformat(ts) {
				var time = new Date().getTime() / 1000 - ts;
				if (time < 60) {
					time = time.toFixed(0) + this.$t('block.secago');
				} else if (time >= 60 && time < 3600) {
					time = Math.floor(time / 60) + this.$t('block.minago');
				} else if (time >= 3600 && time < 3600 * 24) {
					time = Math.floor(time / 3600) + this.$t('block.hourago');
				} else if (time >= 3600 * 24 && time < 3600 * 24 * 30) {
					time = Math.floor((time / 3600) * 24) + this.$t('block.dayago');
				} else if (time >= 3600 * 24 * 30) {
					time = Math.floor((time / 3600) * 24 * 30) + this.$t('block.monago');
				}
				return time;
			},
			formatter2: function(value) {
				if (value >= 1 && value < 1000) {
					return value.toFixed(2) + 'H/s'
				} else if (value >= 1000 && value < 1000000) {
					return (value / 1000).toFixed(2) + 'KH/s'
				} else if (value >= 1000000 && value < 1000000000) {
					return (value / 1000000).toFixed(2) + 'MH/s'
				} else if (value >= 1000000000 && value < 1000000000000) {
					return (value / 1000000000).toFixed(2) + 'GH/s'
				} else if (value >= 1000000000000) {
					return (value / 1000000000000).toFixed(2) + 'TH/s'
				} else if (value == 0) {
					return (0)
				}

			},
			getblockurl(port, value) {
				let url = this.COINS[port].url
				if (port == 11898) {
					return url + '/block.html?hash=' + value;
				} else if (port == 13007) {
					return url + '/?hash=' + value + '#block';
				} else if (port == 11812) {
					// return  url + '/' + type + '?' + type + "_info=" + value;   https://explorer.ird.cash/?hash=
				} else if (port == 8545) {
					// return  url + '/' + type + '/0x' + value;
				} else if (port == 9053) {
					return url + '/blocks/' + value;
				} else {
					// return  url + '/' + type + '/' + value ;
				}
				// return url + '/block/' + value

			},
			getblockaward(port, value) {
				let divisor = this.COINS[port].divisor
				return (value / divisor).toFixed(6)

			},
			isDone(arg) {
				// console.log(arg)
				if (arg === 'DONE') {
					return true
				} else {
					return false
				}
			},
			appendPayment(arg) {
				return "支付：" + arg + "XMR"
			},
			showtable(blockvalue) {
				this.loading = true
				let pagenum = this.currentPage - 1
				let pagesize = this.pagesize
				let that = this
				// console.log(pagesize, pagenum)
				var blockurl = ''
				if (blockvalue === "18081") {
					blockurl = 'https://api.c3pool.org/pool/blocks?page=' + pagenum + '&limit=' + pagesize;
				} else {
					// blockurl = 'https://api.c3pool.org/pool/coin_altblocks/' + blockvalue + '?page=' +
					// 	pagenum + '&limit=' + pagesize;
					blockurl = 'https://api.c3pool.org/pool/coin_altblocks/' + blockvalue + '?page=' +
						pagenum + '&limit=' + pagesize;
				}
				this.blockConfig = {
					method: 'get',
					url: blockurl,
					headers: {}
				};
				// console.log("config")
				// console.log(this.blockConfig)
				axios(this.statsConfig)
					.then(function(response) {
						if (blockvalue === '18081') {
							that.total1 = response.data.pool_statistics.totalBlocksFound
						} else {
							that.total1 = response.data.pool_statistics.altBlocksFound[blockvalue]
						}
					})
					.catch(function(error) {
						console.log(error);
					});

				axios(this.blockConfig)
					.then(function(response) {
						that.$data.tempblockData = []
						for (var item in response.data) {
							var pay = response.data[item].value
							if (blockvalue === "18081") {
								if (response.data[item].valid === true) {
									if (response.data[item].unlocked === false) {
										var b = 30 - (that.netheight - response.data[item].height)
										if (b > 0) {
											pay = ((b * 120) / 60) + this.$t('block.mins');
										} else if (b > -10) {
											pay =this.$t('block.soon');
										} else {
											pay = this.$t('block.delay');
										}
									}
								} else {
									pay = this.$t('block.nullify')
								}
							} else if (response.data[item].valid === true) {
								if (response.data[item].unlocked === false) {
									pay = response.data[item].pay_stage
								}
							} else {
								pay = this.$t('block.nullify')
							}
							var temp = {
								"id": item,
								"ts": formatDate(response.data[item].ts),
								"effort": ((response.data[item].shares * 100 / response.data[item].diff).toFixed(
									0)) + '%',
								"rawaward": that.getblockaward(blockvalue, response.data[item].value),
								"payment": '',
								"height": response.data[item].height,
								"url": that.getblockurl(blockvalue, response.data[item].hash),
								"hash": response.data[item].hash.slice(0, 5) + "******" + response.data[item].hash
									.slice(response.data[item].hash.length - 5, response.data[item].hash.length),
								"stat": response.data[item].pay_stage,
							}

							if (blockvalue === '18081') {
								if (response.data[item].valid === false) {
									temp.rawaward = this.$t('block.nullify')
									temp.payment = this.$t('block.nullify')
								} else if (response.data[item].valid === true) {

									temp.payment = that.getblockaward(blockvalue, response.data[item].value)
								}
								if (response.data[item].unlocked === false) {
									temp.payment = response.data[item].value
									// temp.payment=response.data[item].pay_stage
								}

							} else {
								if (response.data[item].valid === false) {
									temp.rawaward = this.$t('block.nullify')
									temp.payment = this.$t('block.nullify')
								} else if (response.data[item].valid === true) {

									if (response.data[item].unlocked === false && response.data[item].pay_stage !=
										'DONE') {
										temp.payment = response.data[item].pay_stage
									} else if (response.data[item].pay_stage === 'Paid by other block') {
										temp.payment = response.data[item].pay_stage

									} else {
										temp.payment = (response.data[item].pay_value / 1000000000000).toFixed(6)
									}
								}
								// temp.payment = (response.data[item].pay_value / 1000000000000).toFixed(6)
							}
							that.$data.tempblockData.push(temp)
						}
						that.loading = false



						// that.$data.tempblockData = response.data

						// that.handleCurrentChange(1)
						// console.log(JSON.stringify(that.$data.tempblockData));
					})
					.catch(function(error) {
						// console.log("err")
						console.log(error);
					});

			},

			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.$data.pagesize = size;
				this.showtable(this.value)
				// console.log(this.$data.pagesize) //每页下拉显示数据
			},
			handleCurrentChange: function(currentPage) {
				this.$data.currentPage = currentPage;
				this.showtable(this.value)
				// console.log(this.$data.currentPage) //点击第几页
			},
			// handleUserList() {
			//            this.showtable(this.value,this.currentPage,this.pagesize)
			//         },
			// currentChangePage(list, currentPage) {
			// 	let from = (currentPage - 1) * this.$data.pageSize;
			// 	let to = currentPage * this.$data.pageSize;
			// 	this.$data.tempblockData = [];
			// 	for (; from < to; from++) {
			// 		if (list[from]) {
			// 			this.$data.tempblockData.push(list[from]);
			// 		}
			// 	}
			// },
		}
	}
</script>

<style scoped>
	#box {
		width: 60%;
		margin: 50px auto 40px auto;

	}
</style>
